import './ONama.css';

function ONama() {
  return (
    <div className="onama-container">
      <h1>O nama</h1>
      
      <div className="content-section">
        <p className="intro-paragraph">
          KEHSEF d.o.o. je dinamična i inovativna tvrtka sa sjedištem u Zagrebu, Hrvatska. 
          Osnovana s misijom pružanja kvalitetnih IT proizvoda i usluga kibernetičke sigurnosti, 
          KEHSEF d.o.o. je stvorila prepoznatljivo ime na hrvatskom tržištu i šire.
        </p>

        <p>
          Tvrtka posluje u različitim industrijama, nudeći specijalizirana rješenja prilagođena 
          potrebama svojih klijenata koje se kontinuirano mijenjaju i razvijaju.
        </p>

        <div className="highlight-box">
          <h2>Naša vizija</h2>
          <p>
            Tim KEHSEF d.o.o. predano je posvećen izvrsnosti i kvaliteti, ponosno ističući svoju 
            duboku stručnost i pristup usmjeren na potrebe klijenata. Tijekom godina izgradili smo 
            reputaciju pouzdanosti, profesionalnosti i naprednog razmišljanja, što nam je omogućilo 
            da se prilagodimo i napredujemo čak i na konkurentnim tržištima.
          </p>
        </div>

        <p>
          S fokusom na održivi rast, KEHSEF d.o.o. ima za cilj ostaviti trajan utjecaj kako na 
          domaćem tako i na međunarodnom tržištu prihvaćajući moderne prakse i tehnologije.
        </p>

        <div className="partnership-section">
          <h2>Naše partnerstvo</h2>
          <p>
            Ponosni smo na našu suradnju s tvrtkom <strong>Speed Momentum</strong>, s kojom 
            zajedno pružamo vrhunska rješenja i usluge našim klijentima. Ovo partnerstvo 
            omogućuje nam da proširimo naše mogućnosti i ponudimo još kvalitetnije usluge 
            na tržištu.
          </p>
        </div>

        <p>
          Sa sjedištem u živopisnoj hrvatskoj prijestonici Zagrebu, KEHSEF d.o.o. strateški 
          je pozicionirana za povezivanje s klijentima i partnerima širom Europe i svijeta. 
          Dok nastavljamo rasti, tvrtka ostaje predana razvoju dugoročnih partnerstava, 
          ulaganju u inovacije i pozitivnom utjecaju na zajednicu.
        </p>

        <div className="values-section">
          <h2>Naše vrijednosti</h2>
          <ul>
            <li><strong>Izvrsnost</strong> - Težimo najvišim standardima u svakom projektu</li>
            <li><strong>Pouzdanost</strong> - Gradimo dugoročne odnose temeljene na povjerenju</li>
            <li><strong>Inovativnost</strong> - Kontinuirano usvajamo najnovije tehnologije</li>
            <li><strong>Profesionalnost</strong> - Pristupamo svakom izazovu s najvećom pažnjom</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ONama;